import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery, Typography } from '@lacedltd/laced-components'

export const CustomPaymentButtonWrapper = styled.div<{
  loading: boolean
}>(({ loading }) => ({
  marginBottom: loading ? tokens.spacing[6] : 0,

  [mediaQuery.m.min]: {
    width: '100%'
  }
}))

export const ErrorMessage = styled(Typography.Text)({
  color: tokens.color.airPresto[800],
  display: 'block',
  textAlign: 'left'
})
